var path = '/Users/bc/Code/open-source/angular-keypad/src/templates/submit-right.html';
var html = "<button class=\"bc-keypad__key-button bc-keypad__key-button--submit\" data-ng-click=\"vm.rightButtonTrigger($event, vm.bcRightButton)\" angular-ripple aria-role=Submit> <ng-include src=\" vm.bcKeypadConfig.submitTemplate \"></ng-include> </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/submit-right.html
 ** module id = 9
 ** module chunks = 0 1
 **/